import type { ImageProps, TextProps } from '@chakra-ui/react';
import { HStack, Image, Text } from '@chakra-ui/react';
import type { VaultCardInfo } from '@ui/interfaces/vault.interface';
import { formatNumber } from '@ui/utils/formatNumber';

export const Title = (props: TextProps) => (
  <Text
    {...props}
    textStyle="h4"
    color="white"
    fontFamily="luckiestGuy"
    textTransform="uppercase"
  />
);

export const Subtitle = (props: TextProps) => (
  <Text {...props} textStyle="button" color="white" fontWeight={700} />
);

export const AprSubtitle = (props: { apr?: VaultCardInfo['apr'] }) => {
  const { apr } = props;
  return (
    <Subtitle fontSize="18px">
      {apr ? formatNumber(apr * 100) + '% APR' : '-- APR'}
    </Subtitle>
  );
};

interface VectorBackgroundProps {
  background: string;
  vectorSrc: ImageProps['src'];
}
export const VectorBackground = (props: VectorBackgroundProps) => {
  const { background, vectorSrc } = props;
  return (
    <>
      <HStack boxSize="full" background={background}>
        <Image
          h="full"
          src={vectorSrc}
          position="absolute"
          top={0}
          right={0}
          alt="Vector"
        />
      </HStack>
    </>
  );
};
